import { createFileRoute } from "@tanstack/react-router";
import { EstruturaTabelasPage } from "@/paginas/pg_database/database-visualizar-dados";

export const Route = createFileRoute("/_authenticated/database-visualizar-dados")({
  head: () => ({
    meta: [
      { title: "Tabelas e registros — Milky Moo Palmares" },
      {
        name: "description",
        content: "Visualizar estrutura e registros das tabelas do banco (dev).",
      },
      { property: "og:title", content: "Tabelas e registros — Milky Moo Palmares" },
      {
        property: "og:description",
        content: "Visualizar estrutura e registros das tabelas do banco (dev).",
      },
    ],
  }),
  component: EstruturaTabelasPage,
});
